<style scoped="scoped" lang="scss">
.mould-no {
  width: 250px;
  max-height: 100px;
  overflow: auto;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/in/bill/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujurukudanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianhao(jingzhun)')">
            <el-input v-model="yt.conditions.noEqual"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_data_select multiple type="mould" :ids.sync="yt.conditions.mouldIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('rukuleixing')">
            <yi_dictionary_select :max="999" clearable type="MOULD_IN_WAREHOUSING_TYPE" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select :max="999" clearable type="MOULD_IN_ORDER_STATUS" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.beginTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_mold_management_mold_warehousing_batchInsert')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具入库单-新增' } }">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng(stlt)', null, 'w1')" type="primary" v-if="utils.checkPower('web_mold_management_mold_warehousing_create_stlt')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具入库单-新增(赛特莱特)' } }">
          {{ $t('xinzeng(stlt)') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()" v-if="utils.checkPower('web_mold_management_mold_warehousing_export')"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" :loading="scope.row.reviewLoading" @click="review(scope.row)" v-if="scope.row.status === '1' && utils.checkPower('web_mold_management_mold_warehousing_review')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具入库单-审核' } }">
              {{ $t('shenhe') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="scope.row.status === '1' && utils.checkPower('web_mold_management_mold_warehousing_update')" @click="yt.showEditDialog('bianji', scope.row, 'w1', beforeShowEditDialog)">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/mould/in/bill/delete')" v-if="scope.row.status === '1' && utils.checkPower('web_mold_management_mold_warehousing_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @closed="onClose()">
      <!-- 新增弹窗-->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('rukuleixing')" required>
            <yi_dictionary_select :max="999" clearable type="MOULD_IN_WAREHOUSING_TYPE" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('gongsi')">
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxidizhi')">
            <el-input v-model="yt.editObj.address" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujirukushijian')" required>
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.planTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :rows="4" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma/mingcheng')" required>
            <yi_data_select ref="mould" multiple type="mould" :ids.sync="yt.editObj.mouldIds" @change="mouldChange"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yixuanzemojubianhao') + ':'">
            <div class="mould-no">{{ yt.editObj.mouldNos }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="insertSave()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 新增弹窗（赛特莱特）-->
      <template v-if="yt.editObj.action == 'xinzeng(stlt)'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('rukuleixing')" required>
            <yi_dictionary_select :max="999" clearable type="MOULD_IN_WAREHOUSING_TYPE" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shijirukushijian')" required>
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.actualInBillTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('gongsi')" required>
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxidizhi')">
            <el-input v-model="yt.editObj.address" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujifachushijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.estimatedSendTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('yujirukushijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.planTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :rows="4" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma/mingcheng')" required>
            <yi_data_select ref="mould" multiple type="mould" :ids.sync="yt.editObj.mouldIds" @change="mouldChange"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yixuanzemojubianhao') + ':'">
            <div class="mould-no">{{ yt.editObj.mouldNos }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="insertSaveStlt()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗-->
      <template v-if="yt.editObj.action == 'bianji' && !utils.checkPower('web_mold_management_mold_warehousing_create_stlt')">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('rukuleixing')" required>
            <yi_dictionary_select :max="999" clearable type="MOULD_IN_WAREHOUSING_TYPE" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('gongsi')">
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxidizhi')">
            <el-input v-model="yt.editObj.address" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujirukushijian')" required>
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.planTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :rows="4" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma/mingcheng')" required>
            <yi_data_select multiple type="mould" :ids.sync="yt.editObj.mouldId" disabled> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yixuanzemojubianhao') + ':'">
            <div class="mould-no">{{ yt.editObj.mouldNos }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="updateSave()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 编辑弹窗（赛特莱特）-->
      <template v-if="yt.editObj.action == 'bianji' && utils.checkPower('web_mold_management_mold_warehousing_create_stlt')">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('rukuleixing')" required>
            <yi_dictionary_select :max="999" clearable type="MOULD_IN_WAREHOUSING_TYPE" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shijirukushijian')" required>
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.actualInBillTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('gongsi')" required>
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxidizhi')">
            <el-input v-model="yt.editObj.address" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujifachushijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.estimatedSendTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('yujirukushijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.planTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :rows="4" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma/mingcheng')" required>
            <yi_data_select multiple type="mould" :ids.sync="yt.editObj.mouldId" disabled> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yixuanzemojubianhao') + ':'">
            <div class="mould-no">{{ yt.editObj.mouldNos }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="updateSaveStlt()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import XLSX from 'xlsx';

export default {
  name: 'web_mold_management_mold_warehousing_list',
  data() {
    return {
      exportLoading: false,
      selectRows: [],
      columns: [
        {
          label: 'mujurukudanhao',
          prop: 'no'
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no'
        },
        {
          label: 'mujubianma',
          prop: 'mould.code'
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name'
        },
        {
          label: 'rukuleixing',
          prop: 'type',
          type: 'dictionary',
          key: 'MOULD_IN_WAREHOUSING_TYPE'
        },
        {
          label: 'gongsi',
          prop: 'company'
        },
        {
          label: 'lianxidizhi',
          prop: 'address',
          width: 150
        },
        {
          label: 'yujirukushijian',
          prop: 'planTime',
          type: 'time',
          width: 230
        },
        {
          label: 'cangkubianma',
          prop: 'warehouse.code',
          width: 230
        },
        {
          label: 'cangkumingcheng',
          prop: 'warehouse.name',
          width: 230
        },
        {
          label: 'kuqubianma',
          prop: 'warehouseArea.code',
          width: 230
        },
        {
          label: 'kuqumingcheng',
          prop: 'warehouseArea.name',
          width: 230
        },
        {
          label: 'kuweibianma',
          prop: 'warehouseLocation.code',
          width: 230
        },
        {
          label: 'kuweimingcheng',
          prop: 'warehouseLocationId.name',
          width: 230
        },
        {
          label: 'mujubaoyangdanhao',
          prop: 'maintain.no',
          width: 230
        },
        {
          label: 'mujuweixiudanhao',
          prop: 'repair.repairNo',
          width: 230
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'danjuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            '1': {
              color: '#ff7a45',
              text: this.$t('daichuli')
            },
            '2': {
              color: '#9254de',
              text: this.$t('yishenhe')
            }
          }
        },
        {
          label: 'shenheren',
          prop: 'reviewByObject.nickname'
        },
        {
          label: 'shenheshijian',
          prop: 'reviewTime',
          type: 'time',
          width: 230
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    mouldChange(mouldIds) {
      if (!mouldIds) {
        return;
      }
      const items = this.$refs['mould'].items;
      const map = items.reduce((map, item) => {
        map.set(item.id, item);
        return map;
      }, new Map());
      let rows = [];
      for (let i = 0; i < mouldIds.length; i++) {
        const mouldId = mouldIds[i];
        rows.push(map.get(mouldId));
      }

      const mouldNos = rows.map(row => row.no);
      this.yt.editObj.mouldNos = mouldNos.join('、');
      this.selectRows = rows;
    },
    beforeShowEditDialog(row) {
      row.mouldId = [row.mouldId];
      row.mouldNos = row.mould.no;
      return row;
    },
    // 保存新增
    insertSaveStlt() {
      if (this.yt.editObj.company === undefined || this.yt.editObj.company === '') {
        return this.$message.error(this.$t('gongsi') + this.$t('bunengweikong'));
      }
      // 筛选出不是[出库]状态的模具编号
      const mouldNos = this.selectRows.filter(row => row.status !== '7' && row.status !== '9').map(row => row.no);
      if (mouldNos && mouldNos.length > 0) {
        const nos = mouldNos.join(',');
        return this.$message.error(this.$t('mojubianhao') + nos + this.$t('bushichukuhuowaifazhuangtai'));
      }

      //   this.yt.req('POST', '/web/mould/in/bill/batch/insert');
      this.http
        .post('web/mould/in/bill/batch/insert', this.yt.editObj)
        .then(res => {
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
        })
        .catch(err => {
          let msg = err.replace('未知异常：', '');
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'error',
            message: '错误：<br/>' + msg
          });
        });
    },
    // 保存新增
    insertSave() {
      // 筛选出不是[出库]状态的模具编号
      const mouldNos = this.selectRows.filter(row => row.status !== '7' && row.status !== '9').map(row => row.no);
      if (mouldNos && mouldNos.length > 0) {
        const nos = mouldNos.join(',');
        return this.$message.error(this.$t('mojubianhao') + nos + this.$t('bushichukuhuowaifazhuangtai'));
      }
      //this.yt.req('POST', '/web/mould/in/bill/batch/insert');
      this.http
        .post('web/mould/in/bill/batch/insert', this.yt.editObj)
        .then(res => {
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
        })
        .catch(err => {
          let msg = err.replace('未知异常：', '');
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'error',
            message: '错误：<br/>' + msg
          });
        });
    },
    // 保存编辑
    updateSave() {
      this.yt.editObj.mouldId = this.yt.editObj.mouldId[0];
      this.yt.req('POST', '/web/mould/in/bill/update');
    },
    // 保存编辑
    updateSaveStlt() {
      if (this.yt.editObj.company === undefined || this.yt.editObj.company === '') {
        return this.$message.error(this.$t('gongsi') + this.$t('bunengweikong'));
      }
      this.yt.editObj.mouldId = this.yt.editObj.mouldId[0];
      this.yt.req('POST', '/web/mould/in/bill/update');
    },
    // 审核
    review(row) {
      this.$set(row, 'reviewLoading', true);
      this.http
        .post('/web/mould/in/bill/review', row)
        .then(res => {
          if (res.data) {
            this.yt.get(1);
            this.$message.success(this.$t('shenhechenggong'));
          } else {
            this.$message.error(this.$t('shenheshibai'));
          }
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          this.$set(row, 'reviewLoading', false);
        });
    },
    onClose() {
      this.selectRows = [];
    },
    // exportExcel() {
    // 	this.exportLoading = true;
    // 	let params = this.yt.conditions;
    // 	params.createTimeStart = this.yt.conditions.beginTime;
    // 	params.createTimeEnd = this.yt.conditions.endTime;
    // 	return this.http.get('/web/report/export/mould_warehousing_export', { params }).then(res => {
    // 		this.$message.success(this.$t(res.msg));
    // 		this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
    // 	}).catch(error => {
    // 		this.$message.error(this.$t(error));
    // 	}).finally(() => {
    // 		this.exportLoading = false;
    // 	});
    // },
    exportExcel() {
      this.http.get('/web/mould/in/bill/page?page=1&pageSize=10000', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = this.columns.map(i => {
          if (i.label != 'caozuo') {
            return this.$t(i.label);
          }
        });
        let filterFirst = tableFirst.filter(item => {
          if (item) {
            return item;
          }
        });
        let tableData = [];
        tableData.push(filterFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          let dataArr = this.getTableDataArr(listData[i], filterFirst);
          tableData.push(dataArr);
        }
        console.log('tableArr', tableData);
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `模具入库单-${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      });
    },
    getTableDataArr(row, tableFirst) {
      console.log('row', row);
      let dataArr = [];
      dataArr[tableFirst.indexOf(this.$t('mujurukudanhao'))] = row.no;
      dataArr[tableFirst.indexOf(this.$t('mujubianhao'))] = row.mould && row.mould.no;
      dataArr[tableFirst.indexOf(this.$t('mujubianma'))] = row.mould && row.mould.code;
      dataArr[tableFirst.indexOf(this.$t('mujumingcheng'))] = row.mould && row.mould.name;
      if (row.type != null) {
        switch (row.type) {
          case '1':
            dataArr[tableFirst.indexOf(this.$t('rukuleixing'))] = this.$t('outbound_repire_warehousing');
            break;
          case '2':
            dataArr[tableFirst.indexOf(this.$t('rukuleixing'))] = this.$t('outbound_production_warehousing');
            break;
          case '3':
            dataArr[tableFirst.indexOf(this.$t('rukuleixing'))] = this.$t('postpartum_care_storage');
            break;
          case '4':
            dataArr[tableFirst.indexOf(this.$t('rukuleixing'))] = this.$t('Postpartum_maintenance_and_storage');
            break;
          case '5':
            dataArr[tableFirst.indexOf(this.$t('rukuleixing'))] = this.$t('xinmoruku');
            break;
          case '6':
            dataArr[tableFirst.indexOf(this.$t('rukuleixing'))] = this.$t('bushengchantuicang');
            break;
          default:
            dataArr[tableFirst.indexOf(this.$t('rukuleixing'))] = '';
            break;
        }
      }
      dataArr[tableFirst.indexOf(this.$t('gongsi'))] = row.company;
      dataArr[tableFirst.indexOf(this.$t('lianxidizhi'))] = row.address;
      dataArr[tableFirst.indexOf(this.$t('yujirukushijian'))] = row.planTime && this.dayjs(row.planTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[tableFirst.indexOf(this.$t('cangkubianma'))] = row.warehouse && row.warehouse.code;
      dataArr[tableFirst.indexOf(this.$t('cangkumingcheng'))] = row.warehouse && row.warehouse.name;
      dataArr[tableFirst.indexOf(this.$t('kuqubianma'))] = row.warehouseArea && row.warehouseArea.code;
      dataArr[tableFirst.indexOf(this.$t('kuqumingcheng'))] = row.warehouseArea && row.warehouseArea.name;
      dataArr[tableFirst.indexOf(this.$t('kuweibianma'))] = row.warehouseLocation && row.warehouseLocation.code;
      dataArr[tableFirst.indexOf(this.$t('kuweimingcheng'))] = row.warehouseLocationId && row.warehouseLocationId.name;
      dataArr[tableFirst.indexOf(this.$t('mujubaoyangdanhao'))] = row.maintain && row.maintain.no;
      dataArr[tableFirst.indexOf(this.$t('mujuweixiudanhao'))] = row.repair && row.repair.repairNo;
      dataArr[tableFirst.indexOf(this.$t('beizhu'))] = row.remark;
      if (row.status != null) {
        switch (row.status) {
          case '1':
            dataArr[tableFirst.indexOf(this.$t('danjuzhuangtai'))] = this.$t('daichuli');
            break;
          case '2':
            dataArr[tableFirst.indexOf(this.$t('danjuzhuangtai'))] = this.$t('yishenhe');
            break;
        }
      } else {
        dataArr[tableFirst.indexOf(this.$t('danjuzhuangtai'))] = '';
      }
      dataArr[tableFirst.indexOf(this.$t('shenheren'))] = row.reviewByObject && row.reviewByObject.nickname;
      dataArr[tableFirst.indexOf(this.$t('shenheshijian'))] = row.reviewTime && this.dayjs(row.reviewTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[tableFirst.indexOf(this.$t('chuangjianren'))] = row.createByObject && row.createByObject.nickname;
      dataArr[tableFirst.indexOf(this.$t('chuangjianshijian'))] = row.createTime && this.dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss');

      if (row.actualInBillTime != null) {
        dataArr[tableFirst.indexOf(this.$t('shijirukushijian'))] = row.actualInBillTime && this.dayjs(row.actualInBillTime).format('YYYY-MM-DD HH:mm:ss');
      } else {
        dataArr[tableFirst.indexOf(this.$t('shijirukushijian'))] = '';
      }
      if (row.estimatedSendTime != null) {
        dataArr[tableFirst.indexOf(this.$t('yujifachushijian'))] = row.estimatedSendTime && this.dayjs(row.estimatedSendTime).format('YYYY-MM-DD HH:mm:ss');
      } else {
        dataArr[tableFirst.indexOf(this.$t('yujifachushijian'))] = '';
      }
      return dataArr;
    }
  }
};
</script>
